// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 用户行为追踪 POST /user/wx_track/${param0} */
export async function userWxTrackWxIdUsingPOST(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.userWxTrackWxIdUsingPOSTParams,
  options?: { [key: string]: any },
) {
  const { wxId: param0, ...queryParams } = params;
  return request<API.BaseResultstring>(`/user/wx_track/${param0}`, {
    method: 'POST',
    params: {
      ...queryParams,
    },
    ...(options || {}),
  });
}
